import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SharedCommonModule } from '../../shared/shared-common.module';
import { SharedPopupsModule } from '../../shared/shared-popups.module';

import { NgxSkeletonModule } from 'ngx-skeleton';

// List Components

import { BlogPostsListComponent } from '../../shared/partials/main-lists/blog-posts-list/blog-posts-list.component';
import { BlogPostsListItemComponent } from '../../shared/partials/main-lists/blog-posts-list/blog-posts-list-item/blog-posts-list-item.component';
import { DynamicPostStatusComponent } from '../../shared/partials/main-lists/blog-posts-list/blog-posts-list-item/dynamic-post-status/dynamic-post-status.component';
import { ContactsListComponent } from '../../shared/partials/main-lists/contacts-list/contacts-list.component';
import { ContactsListItemComponent } from '../../shared/partials/main-lists/contacts-list/contacts-list-item/contacts-list-item.component';
import { DomainsListComponent } from '../../shared/partials/main-lists/domains-list/domains-list.component';
import { EarningsListComponent } from '../../shared/partials/main-lists/earnings-list/earnings-list.component';
import { EarningsListItemComponent } from '../../shared/partials/main-lists/earnings-list/earnings-list-item/earnings-list-item.component';
import { FunnelsListComponent } from '../../shared/partials/main-lists/funnels-list/funnels-list.component';
import { FunnelListItemComponent } from '../../shared/partials/main-lists/funnels-list/funnel-list-item/funnel-list-item.component';
import { OffersListComponent } from '../../shared/partials/main-lists/offers-list/offers-list.component';
import { OfferListItemComponent } from '../../shared/partials/main-lists/offers-list/offer-list-item/offer-list-item.component';
import { OfferListMinimalItemComponent } from '../../shared/partials/main-lists/offers-list/offer-list-minimal-item/offer-list-minimal-item.component';
import { DynamicOfferStatusComponent } from '../../shared/partials/main-lists/offers-list/offer-list-item/dynamic-offer-status/dynamic-offer-status.component';
import { PagesListComponent } from '../../shared/partials/main-lists/pages-list/pages-list.component';
import { PageListItemComponent } from '../../shared/partials/main-lists/pages-list/page-list-item/page-list-item.component';
import { DynamicPageStatusComponent } from '../../shared/partials/main-lists/pages-list/page-list-item/dynamic-page-status/dynamic-page-status.component';
import { PageSettingsModalComponent } from '../../shared/partials/main-lists/pages-list/page-settings-modal/page-settings-modal.component';
import { LegalPageEditorModalComponent } from '../../shared/partials/main-lists/pages-list/legal-page-editor-modal/legal-page-editor-modal.component';
import { ProductsListComponent } from '../../shared/partials/main-lists/products-list/products-list.component';
import { ProductListItemComponent } from '../../shared/partials/main-lists/products-list/product-list-item/product-list-item.component';
import { RefundListComponent } from '../../shared/partials/main-lists/refund-list/refund-list.component';
import { RefundListItemComponent } from '../../shared/partials/main-lists/refund-list/refund-list-item/refund-list-item.component';
import { RefundItemStatusLabelComponent } from '../../shared/partials/main-lists/refund-list/refund-list-item/refund-item-status-label/refund-item-status-label.component';
import { StudentsListComponent } from '../../shared/partials/main-lists/students-list/students-list.component';
import { StudentListItemComponent } from '../../shared/partials/main-lists/students-list/students-list-item/students-list-item.component';
import { StudentReportDetailComponent } from '../../shared/partials/main-lists/students-list/student-report-detail/student-report-detail.component';
import { SubscribersListComponent } from '../../shared/partials/main-lists/subscribers-list/subscribers-list.component';
import { SubscriberItemPopupComponent } from '../../shared/partials/main-lists/subscribers-list/subscriber-item-popup/subscriber-item-popup.component';
import { TransactionsListComponent } from '../../shared/partials/main-lists/transactions-list/transactions-list.component';
import { TransactionsListItemComponent } from '../../shared/partials/main-lists/transactions-list/transactions-list-item/transactions-list-item.component';
import { TransactionInfoPopupComponent } from '../../shared/partials/main-lists/transactions-list/transactions-list-item/transaction-info-popup/transaction-info-popup.component';

// List Utilities
import { LoadingListComponent } from '../../shared/partials/main-lists/loading-list/loading-list.component';
import { LoadingListItemComponent } from '../../shared/partials/main-lists/loading-list/loading-list-item/loading-list-item.component';
import { ListThumbnailComponent } from '../../shared/partials/main-lists/list-thumbnail/list-thumbnail.component';
import { ListIsEmptyComponent } from '../../shared/partials/main-lists/misc/list-is-empty/list-is-empty.component';
import { NoResultsSearchComponent } from '../../shared/partials/main-lists/misc/no-results-search/no-results-search.component';
import { PaginationUnitComponent } from '../../shared/partials/main-lists/lists-parts/pagination-unit/pagination-unit.component';
import { PaymentModule } from '../payment/payment.module';

const LISTS_COMPONENTS = [
  // Blog Lists
  BlogPostsListComponent,
  BlogPostsListItemComponent,
  DynamicPostStatusComponent,

  // Contact Lists
  ContactsListComponent,
  ContactsListItemComponent,

  // Domain Lists
  DomainsListComponent,

  // Earnings Lists
  EarningsListComponent,
  EarningsListItemComponent,

  // Funnel Lists
  FunnelsListComponent,
  FunnelListItemComponent,

  // Offer Lists
  OffersListComponent,
  OfferListItemComponent,
  OfferListMinimalItemComponent,
  DynamicOfferStatusComponent,

  // Page Lists
  PagesListComponent,
  PageListItemComponent,
  DynamicPageStatusComponent,
  PageSettingsModalComponent,
  LegalPageEditorModalComponent,

  // Product Lists
  ProductsListComponent,
  ProductListItemComponent,

  // Refund Lists
  RefundListComponent,
  RefundListItemComponent,
  RefundItemStatusLabelComponent,

  // Student Lists
  StudentsListComponent,
  StudentListItemComponent,
  StudentReportDetailComponent,

  // Subscriber Lists
  SubscribersListComponent,
  SubscriberItemPopupComponent,

  // Transaction Lists
  TransactionsListComponent,
  TransactionsListItemComponent,
  TransactionInfoPopupComponent,

  // Utilities
  LoadingListComponent,
  LoadingListItemComponent,

  ListIsEmptyComponent,
  NoResultsSearchComponent,
  PaginationUnitComponent,
];

/**
 * ListsModule
 *
 * Purpose: Contains all data list components for displaying collections of:
 * - Affiliates and affiliate links
 * - Blog posts and articles
 * - Contacts and subscribers
 * - Domains
 * - Earnings and transactions
 * - Funnels and pages
 * - Offers and products
 * - Refunds
 * - Students and reports
 * - Common list utilities (pagination, loading states, empty states)
 */
@NgModule({
  declarations: LISTS_COMPONENTS,
  imports: [
    SharedCommonModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    InfiniteScrollModule,
    NgxSkeletonModule,
    SharedPopupsModule,
  ],
  exports: LISTS_COMPONENTS,
})
export class ListsModule {}
